import Fire from '@carvana/icons/Fire';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import React from 'react';
import styled from 'styled-components';
import { SectionViewedLogger, SectionViewedLoggerProps } from '@/vdp/Analytics';
import Eye from '~/icons/Eye';

export const Section: React.FC<SectionViewedLoggerProps> = styled(
  SectionViewedLogger
)`
  margin-bottom: -20px;
  padding: 30px 12px 20px;
  position: relative;
  z-index: 1;

  @media (min-width: ${legacyBreakpoints.m}px) {
    padding: 40px 32px 20px;
  }
`;
export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: var(--cvna-color-grey-5);
  max-width: 768px;
  margin: auto;
  font-size: 12px;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .count {
    font-weight: 700;
    color: var(--cvna-color-blue-6);
    font-size: 22px;
  }

  .flame-on-top {
    position: relative;
  }

  .copy,
  .count {
    margin-left: 5px;
  }

  &:nth-of-type(2) {
    margin-left: 30px;
  }

  @media (min-width: ${legacyBreakpoints.m}px) {
    .copy,
    .count {
      margin-left: 7px;
    }

    &:nth-of-type(2) {
      margin-left: 35px;
    }
  }
`;

export const GrayEye = styled(Eye)`
  color: var(--cvna-color-grey-3);
  fill: var(--cvna-color-grey-3);

  &:hover {
    color: var(--cvna-color-grey-3);
    fill: var(--cvna-color-grey-3);
  }
`;

export const RedFlame = styled(Fire)`
  color: var(--cvna-color-red-2);
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
`;
